/**
 * auth 레이어 공용 타입.
 *
 * 개별 파일이 서로 의존성을 끌어가지 않도록 타입만 모아둔다.
 */

export interface AdminSessionContext {
  readonly clerkUserId: string;
  readonly sessionId: string;
  readonly email: string;
  readonly name: string | null;
  /** Clerk 세션 JWT (getToken() 결과). Worker 측 검증용. */
  readonly token: string;
}

/** 로그인/행위 이벤트 페이로드 (Jupiter #5 Assistant 이 실제 LLM 평가 수행). */
export interface AnomalyEvent {
  readonly actor: string; // clerk_user_id
  readonly eventType: 'login' | 'action' | 'api_call';
  /** 임의의 구조화 시그널 (ip, ua, timezone, action_type 등). */
  readonly signal: Record<string, unknown>;
  /** 이벤트 발생 시각 (ISO 8601). */
  readonly occurredAt: string;
}

/** AI 평가 결과 (Jupiter 가 채워주는 schema). */
export interface AnomalyAssessment {
  readonly verdict: 'normal' | 'suspicious' | 'critical';
  readonly reason: string;
  readonly actionTaken: 'none' | '2fa_required' | 'account_locked';
}

/** 고위험 액션 분류 (docs/specs/superadmin.md §1.2 Step-up 대상). */
export type StepUpAction =
  | 'promote_live'
  | 'delete_user'
  | 'approve_refund'
  | 'panic_rollback';

export const STEP_UP_ACTIONS: readonly StepUpAction[] = [
  'promote_live',
  'delete_user',
  'approve_refund',
  'panic_rollback',
];

export function isStepUpAction(value: string): value is StepUpAction {
  return (STEP_UP_ACTIONS as readonly string[]).includes(value);
}
